import axios from "axios";
import { getAuthToken } from "./authToken";
import { store } from "../redux/store";
import { logoutUser } from "../redux/slices/AuthSlice";
import { clearValuator } from "../redux/slices/ValuatorDetailSlice";
import { toast } from "react-toastify";

const apiBaseUrl =
	window.APP_CONFIG?.API_BASE_URL;
	// process.env.REACT_APP_API_BASE_URL ||
	// "";

const api = axios.create({
	baseURL: apiBaseUrl,
	withCredentials: true,
});

api.interceptors.request.use(
	(config) => {
		const token = getAuthToken();

		if (token) {
			config.headers = config.headers || {};
			config.headers.Authorization = `Bearer ${token}`;
			// config.headers.Authorization = "Bearer invalid-test-token";
		}

		return config;
	},
	(error) => Promise.reject(error),
);
let isLoggingOut = false;

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401 && !isLoggingOut) {
//       isLoggingOut = true;
// 	  alert("Your session has expired. Please log in again.")
//  toast.info("Your session has expired. Please log in again.");
//       sessionStorage.setItem("isLoggingOut", "true");

//       await store.dispatch(logoutUser());
//       store.dispatch(clearValuator());

//       sessionStorage.removeItem("isLoggingOut");

//       window.location.replace("/login");
//     }

//     return Promise.reject(error);
//   }
// );
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const status = error.response?.status;

		const responseData = error.response?.data;

		// Convert response to string so we can search the exception message
		const responseMessage =
			typeof responseData === "string"
				? responseData
				: JSON.stringify(responseData || "");

		const isTokenExpired =
			status === 401 ||
			responseMessage.includes("SecurityTokenExpiredException") ||
			responseMessage.includes("IDX10223") ||
			responseMessage.includes("Lifetime validation failed. The token is expired");

		if (isTokenExpired && !isLoggingOut) {
			isLoggingOut = true;

			const message =
				"Your session has expired. Please log in again.";

			alert(message);
			toast.info(message);

			sessionStorage.setItem("isLoggingOut", "true");

			try {
				await store.dispatch(logoutUser());
				store.dispatch(clearValuator());
			} finally {
				sessionStorage.removeItem("isLoggingOut");
				window.location.replace("/login");
			}
		}

		return Promise.reject(error);
	}
);

export default api;
